import React from 'react';

import { ColumnHeaderSortable } from '../../DataTable/index.jsx';
import { CurrencyFigure } from '../../Figure/index.jsx';

import Column from './base.jsx';


var columnOptions = {
  id: 'h',
  title: 'Market Cap (USD)'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  get rightAlign() {
    return true;
  }
}


var DetailColumn = function(props) {
  return (
    <td className="text-right">
      <CurrencyFigure amount={props.row.marketCap * props.row.tokenUSD} formatter="large" zeroIsBlank />
    </td>
  );
}


class MarketCapUSD extends Column {
  get default() {
    return true;
  }

  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  sortAscending(a, b) {
    if (a.marketCap < b.marketCap) {
      return -1;
    }
    if (a.marketCap > b.marketCap) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (a.marketCap < b.marketCap) {
      return 1;
    }
    if (a.marketCap > b.marketCap) {
      return -1;
    }
    return super.sortDescending(a, b);
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default MarketCapUSD;

